<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">
        <a
            v-if="!logo"
            class="header__logo"
            href="/"
            @click.prevent="$emit('clickEvent', ['/', $event])"
        >
          <img
            :src="config.images.icon.webp"
            class="header__logo-image js-logo"
            alt="logo"
            @load="loadImage"
          />
        </a>

        <div
            v-else
            class="header__logo-container"
        >
          <a
              v-for="image in logo"
              :key="image"
              class="header__logo"
              href="#"
              @click.prevent="$emit('click', ['/', $event])"
          >
            <img
                :src="`img/${image}`"
                class="header__logo-image"
                alt="logo"
            />
          </a>
        </div>
        <div class="header__logo-name">{{ blogerName }}</div>
        <div class="header__social">
          <Socials :config="config" @click-social="clickSocial" />
        </div>
      </div>
      <div class="header__text" v-html="headerText"></div>
    </div>
  </header>
</template>

<script>
import { defineComponent } from 'vue'
import Socials from '../socials/index.vue'

export default defineComponent({
  name: 'Header-block',
  components: {
    Socials
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    logoLoaded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      logo: this.config.logo,
      blogerName: this.config.blogerName,
      headerText: this.config.headerText
    }
  },
  methods: {
    clickSocial (data) {
      this.$emit('clickEvent', data)
    }
  }
})
</script>

<style lang="scss" src="./style.scss">
</style>
